import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  selectSignUpType,
  selectSignUpUser,
  selectSignUpInvite,
  selectSignUpProperty,
} from '../../../redux/auth/selectors';
import { selectMe } from '../../../redux/me/selectors';

import { get } from 'lodash';
import { parseErrorMessage } from '../../../util/util';

import {
  TYPE_CONTACT_INVITE,
  TYPE_GENERIC_HOUSEHOLD,
  TYPE_GENERIC_HOUSEHOLD_INVITE,
  TYPE_HOUSEHOLD_INVITE,
} from '../config';

import API from '../../../services/API';
import { statusHandler } from '../../../services/services';
import ImageService from '../../../services/ImageService';

import containerStyles from './Confirm.scss';
import qmStyles from '../../../theme/qmStyles';

import ModalWrapper from '../../../components/ModalWrapper';
import CommunicationCarousel from './CommunicationCarousel';
import Button from '../../../components/Button';
import PropertyPreview from '../components/PropertyPreview';
import ContactUs from '../components/ContactUs';

import artInvite from '../assets/art-invite.png';
import artInviteHousehold from '../assets/art-invite-household.png';

class Confirm extends Component {
  static propTypes = {
    navigateNext: PropTypes.func.isRequired,
    signupType: PropTypes.string.isRequired,

    me: PropTypes.shape({
      first_name: PropTypes.string.isRequired,
    }),
    userData: PropTypes.shape({
      first_name: PropTypes.string.isRequired,
    }),
    inviteData: PropTypes.shape({
      sender: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    }),
    propertyData: PropTypes.object,

    type: PropTypes.string,
    householdMember: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  };

  static defaultProps = {
    me: null,
    userData: null,
    inviteData: null,
    propertyData: null,
    type: '',
  };

  state = {
    communicationModalIsOpen: false,
  };

  handleNext = () => {
    const { inviteData, navigateNext } = this.props;
    if (this.state.error) {
      navigateNext();
    } else if (inviteData) {
      API.api
        .post(`/invitation/${inviteData.invitation_id}/accept`, {
          token: inviteData.token,
          status: 'ACCEPTED',
        })
        .then(statusHandler)
        .then(() => {
          navigateNext();
        })
        .catch(error => {
          this.setState({
            error: (error && error.data) || null,
          });
        });
    } else {
      navigateNext();
    }
  };

  openCommunicationModal = () => {
    this.setState({ communicationModalIsOpen: true });
  };

  closeCommunicationModal = () => {
    this.setState({ communicationModalIsOpen: false });
  };

  renderPhotoUploaded = () => {
    const { propertyData, inviteData } = this.props;

    const property = get(inviteData, 'related_property') || propertyData;

    return (
      <>
        <div className={containerStyles.checkHeader}>
          {/* <div
            className={`qm-icon-subtask-complete ${containerStyles.checkIcon}`}
          />
          <p className={containerStyles.checkText}>You're all set!</p> */}
        </div>
        <p style={{ marginBottom: qmStyles.gutter }}>
          Continue to join{` `}
          <b>{get(inviteData, 'sender.name')}</b>
          {` `}at this property:
        </p>
        {!!property && (
          <PropertyPreview
            image={ImageService().getFull(property.image)}
            property={property}
          />
        )}
        <Button
          onClick={this.handleNext}
          text="Join this property"
          style={{ width: 360, margin: `${qmStyles.gutter}px 0` }}
        />
        <ContactUs />
      </>
    );
  };

  renderBusinessConnection = () => {
    const { me, userData, inviteData, navigateNext } = this.props;
    const { error } = this.state;
    if (!(inviteData && inviteData.sender)) {
      return this.renderPhotoUploaded();
    }
    return (
      <div className={containerStyles.companyConnectionContainer}>
        <div className={containerStyles.checkHeader}>
          {/* <div
            className={`qm-icon-subtask-complete ${containerStyles.checkIcon}`}
          />
          <p className={containerStyles.checkText}>You're all set!</p> */}
        </div>
        {inviteData.invitation_type === 'BUSINESS' ? (
          <img
            src={ImageService().getFull(inviteData.sender.image)}
            style={{ width: 140 }}
          />
        ) : (
          <img src={artInviteHousehold} />
        )}
        <div className={containerStyles.connectedWithContainer}>
          <p className={containerStyles.connectedWith}>
            {`${get(userData, 'first_name') ||
              get(me, 'first_name')}, continue to connect with:`}
          </p>
          <p className={containerStyles.companyName}>
            <b>{get(inviteData, 'sender.name')}</b>
          </p>
        </div>
        {error && (
          <p style={{ color: 'red', paddingBottom: '1em' }}>
            {parseErrorMessage({ error })}
          </p>
        )}
        <Button
          onClick={this.handleNext}
          text={error ? 'Continue Anyways' : 'Accept Connection'}
          style={{
            width: 360,
            backgroundColor: error ? 'white' : qmStyles.qmGreen,
            color: error ? qmStyles.greyDarkest : 'white',
            marginBottom: qmStyles.gutter,
          }}
        />
        <ContactUs />
      </div>
    );
  };

  renderInterest = () => (
    <>
      <h3 className={containerStyles.title}>Thank you for your interest</h3>
      <p className={containerStyles.subTitle}>
        We will be in touch with you as soon as possible
      </p>
      <Button
        text="Resend"
        style={{ width: 360, marginBottom: qmStyles.doubleGutter }}
      />
    </>
  );

  renderHouseholdRequest = () => {
    const { communicationModalIsOpen } = this.state;
    const { navigateNext, householdMember } = this.props;

    return (
      <>
        <h3 className={containerStyles.title}>
          Household Join Request Sent{' '}
          {householdMember &&
            `to ${householdMember.firstName} ${householdMember.lastName}`}
        </h3>
        {householdMember && (
          <p className={[containerStyles.subTitle]}>
            <span style={{ color: qmStyles.qmGreen }}>Tip: </span>Be sure to
            remind {`${householdMember.firstName} ${householdMember.lastName}`}{' '}
            to accept your invitation!
          </p>
        )}
        <ModalWrapper
          closeModal={this.closeCommunicationModal}
          isOpen={communicationModalIsOpen}
          className={containerStyles.communicationModal}
        >
          {({ isOpen, closeModal }) => (
            <CommunicationCarousel closeModal={closeModal} />
          )}
        </ModalWrapper>
        <img
          src={artInvite}
          alt="three people connection"
          style={{ marginBottom: qmStyles.gutter }}
        />
        <p className={containerStyles.subTitle}>
          You will receive an email when accepted!
        </p>
        <Button
          onClick={this.openCommunicationModal}
          text="Learn more about Quartermaster"
          style={{
            backgroundColor: qmStyles.qmGreen,
            color: 'white',
            marginBottom: qmStyles.doubleGutter,
            width: 360,
          }}
        />
        <ContactUs />
      </>
    );
  };

  renderConfirmType = () => {
    const { signupType, type } = this.props;

    if (type === 'REQUEST') {
      return this.renderHouseholdRequest();
    }

    switch (signupType) {
      case TYPE_GENERIC_HOUSEHOLD:
        return this.renderHouseholdRequest();
      case TYPE_HOUSEHOLD_INVITE:
      case TYPE_GENERIC_HOUSEHOLD_INVITE:
        return this.renderPhotoUploaded();
      case TYPE_CONTACT_INVITE:
        return this.renderBusinessConnection();
      default:
        return this.renderHouseholdRequest();
    }
  };

  render() {
    return (
      <div className={containerStyles.container}>
        {this.renderConfirmType()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  signupType: selectSignUpType(state),
  userData: selectSignUpUser(state),
  me: selectMe(state),
  inviteData: selectSignUpInvite(state),
  propertyData: selectSignUpProperty(state),
  householdMember: state.householdMember,
});

export default connect(
  mapStateToProps,
  null,
)(Confirm);
